export default __webpack_public_path__ + "static/m-werksman-86e96cbbd824a043d1310889492a6b0b.png";